/* Badeloft Body Fit: concept widget. Tub shapes come from centreline cuts of each tub's 3D model. */
(function (root) {
  'use strict';

  var MODES = [
    { id: 'up', label: 'Sitting up', phi: 60 },
    { id: 'recline', label: 'Reclined', phi: 47 },
    { id: 'lie', label: 'Lying back', phi: 37 }
  ];
  function sizesOf(tubs) { return Object.keys(tubs).sort(function (a, b) { return tubs[a].specLen - tubs[b].specLen; }); } // smallest first
  var OVERFLOW_BELOW_RIM = 3.0; // fallback only, for a tub without a data-sheet "depth to overflow"
  var STYLES = {
    stretch: { name: 'Full stretch', rank: 2 },
    classic: { name: 'Classic recline', rank: 1 },
    upright: { name: 'Upright soak', rank: 0 }
  };
  var DEG = Math.PI / 180;

  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function r1(v) { return (Math.round(v * 10) / 10).toFixed(1); }
  function ftin(h) { var t = Math.round(h), f = Math.floor(t / 12); return f + '′' + (t % 12) + '″'; }

  /* ---------- tub geometry ---------- */
  function prep(t) {
    if (t._p) return t._p;
    function fill(a) {
      var r = a.slice(), last = null, i;
      for (i = 0; i < r.length; i++) { if (r[i] == null) r[i] = last; else last = r[i]; }
      last = null;
      for (i = r.length - 1; i >= 0; i--) { if (r[i] == null) r[i] = last; else last = r[i]; }
      return r;
    }
    var raw = fill(t.inner), outer = fill(t.outer), silTop = fill(t.silTop), silBot = fill(t.silBot);
    var n = raw.length, step = t.step;
    // close narrow pits (the drain recess) so nobody "sits" in the drain: max filter then min filter over ~3in
    function filt(a, w, fn) { return a.map(function (_, i) { var s = a.slice(Math.max(0, i - w), Math.min(a.length, i + w + 1)); return fn.apply(null, s); }); }
    var inner = filt(filt(raw, 3, Math.max), 3, Math.min);
    var mid0 = Math.floor(n / 4), mid1 = Math.floor(3 * n / 4);
    t.floor = Math.min.apply(null, inner.slice(mid0, mid1));
    function interp(arr, x) {
      var i = clamp(x / step, 0, n - 1), i0 = Math.floor(i), i1 = Math.min(n - 1, i0 + 1), f = i - i0;
      return arr[i0] * (1 - f) + arr[i1] * f;
    }
    function at(x) { return (x < 0 || x > t.L) ? -Infinity : interp(inner, x); }
    // the floor under a point: the inner surface where it slopes less than ~20 deg (a raised foot platform or a gentle ramp, as on the
    // BW-06, is floor you rest on; the curved end walls are not). null where the surface is steep or beyond the ends
    function floorAt(x) {
      if (x < 1 || x > t.L - 1) return null;
      var slope = Math.abs(interp(inner, x + 1) - interp(inner, x - 1)) / 2;
      return slope < 0.35 ? interp(inner, x) : null;
    }
    var q = Math.floor(n / 4), rimL = 0, rimR = 0, i;
    for (i = 0; i < q; i++) rimL = Math.max(rimL, inner[i]);
    for (i = n - q; i < n; i++) rimR = Math.max(rimR, inner[i]);
    // wall position tables: x of the inner surface at height y, scanning in from each end
    var dy = 0.1, LW = [], RW = [];
    for (var y = 0; y <= Math.max(rimL, rimR) + dy; y += dy) {
      var xl = null, xr = null, x;
      if (y < rimL) for (x = 0; x <= t.L / 2; x += 0.05) { if (at(x) < y) { xl = x; break; } }
      if (y < rimR) for (x = t.L; x >= t.L / 2; x -= 0.05) { if (at(x) < y) { xr = x; break; } }
      LW.push(xl); RW.push(xr);
    }
    function leftWall(y) { if (y >= rimL) return -Infinity; var v = LW[Math.round(y / dy)]; return v == null ? -Infinity : v; }
    function rightWall(y) { if (y >= rimR) return Infinity; var v = RW[Math.round(y / dy)]; return v == null ? Infinity : v; }
    function hipWidth(x) {
      var a = t.hipW; if (x <= a[0][0]) return a[0][1];
      for (var j = 1; j < a.length; j++) if (a[j][0] >= x) { var f = (x - a[j - 1][0]) / (a[j][0] - a[j - 1][0]); return a[j - 1][1] * (1 - f) + a[j][1] * f; }
      return a[a.length - 1][1];
    }
    var water = t.overflow != null ? t.floor + t.overflow : t.rimLow - OVERFLOW_BELOW_RIM;
    // interior length measured just below the side rim, and flat floor length
    var yRim = t.rimLow - 0.5, innerLen = rightWall(yRim) - leftWall(yRim);
    var flat = 0; for (i = 0; i < n; i++) if (inner[i] <= t.floor + 0.6) flat += step;
    t._p = { inner: inner, outer: outer, silTop: silTop, silBot: silBot, at: at, floorAt: floorAt, leftWall: leftWall, rightWall: rightWall,
      hipWidth: hipWidth, water: water, rimL: rimL, rimR: rimR, innerLen: innerLen, flatLen: flat };
    return t._p;
  }

  /* ---------- body ---------- */
  // Segment lengths as fractions of height (Drillis & Contini / Winter); widths and depths differ by sex.
  function bodyDims(H, lb, sex) {
    var f = sex === 'f', bmi = lb / (H * H) * 703, bf = clamp(Math.sqrt(bmi / (f ? 22 : 23)), 0.85, 1.45), sb = Math.sqrt(bf);
    return {
      H: H, lb: lb, bf: bf, sex: f ? 'f' : 'm',
      torso: (f ? 0.291 : 0.288) * H, neck: 0.045 * H, headR: (f ? 0.056 : 0.058) * H,
      thigh: (f ? 0.243 : 0.245) * H, shank: (f ? 0.244 : 0.246) * H, ankleH: 0.039 * H, foot: (f ? 0.108 : 0.115) * H,
      upperArm: (f ? 0.168 : 0.172) * H, foreArm: (f ? 0.152 : 0.157) * H,
      tTorso: (f ? 0.118 : 0.128) * H * bf, tPelvis: (f ? 0.128 : 0.118) * H * bf,
      tThigh: (f ? 0.098 : 0.092) * H * bf, tShank: (f ? 0.06 : 0.063) * H * sb,
      tArm: (f ? 0.045 : 0.051) * H * sb, tFoot: 0.045 * H, tNeck: (f ? 0.055 : 0.062) * H,
      hipW: (f ? 0.225 : 0.2) * H * bf, sole: 0.036 * H, // sole: ankle joint to the sole of the foot
      volGal: lb * 0.4536 / 1.01 * 0.264172
    };
  }

  /* ---------- pose + fit ---------- */
  function modesFor(t) { return t.seat ? MODES.filter(function (m) { return m.id === 'up'; }) : MODES; } // a built-in seat (deep soaking tubs) has a vertical wall behind it: sitting up only
  function fit(t, b, modeId) {
    var P = prep(t), mode = modesFor(t).filter(function (m) { return m.id === modeId; })[0] || modesFor(t)[Math.min(1, modesFor(t).length - 1)];
    var phi = mode.phi * DEG, u = { x: -Math.cos(phi), y: Math.sin(phi) }, nb = { x: -Math.sin(phi), y: -Math.cos(phi) };
    var rP = b.tPelvis / 2, rT = b.tTorso / 2, floor = t.floor;
    // head direction tilts forward of the torso
    var psi = Math.min(mode.phi + 22, 84) * DEG, hd = { x: -Math.cos(psi), y: Math.sin(psi) };
    var rel = [], s, a;
    // upperFree (3D view only, fraction of the torso kept in the wall check): the head, and any torso above that fraction, are left out,
    // because the 3D figure aims its head on its own and curls its upper back over the rim; the head circle jammed against the curved
    // head end pushed the hips (and knees) forward
    var top = b.upperFree ? b.torso * b.upperFree : b.torso;
    for (s = 0; s <= top + 1e-6; s += b.torso / 30) {
      var rr = rP + (rT - rP) * (s / b.torso);
      rel.push({ x: u.x * s + nb.x * rr, y: u.y * s + nb.y * rr });
    }
    for (a = 150; a <= 270; a += 12) rel.push({ x: rP * Math.cos(a * DEG), y: rP * Math.sin(a * DEG) }); // buttock curve
    var sh = { x: u.x * b.torso, y: u.y * b.torso };
    var nk = { x: sh.x + u.x * b.neck, y: sh.y + u.y * b.neck };
    var hc = { x: nk.x + hd.x * b.headR * 0.9, y: nk.y + hd.y * b.headR * 0.9 };
    if (!b.upperFree) for (a = 0; a < 360; a += 20) rel.push({ x: hc.x + b.headR * Math.cos(a * DEG), y: hc.y + b.headR * Math.sin(a * DEG) });

    // a built-in seat (deep soaking tubs): the hips sit on it, so the back wall is read only from body points above the seat top
    // (below it the seat's own front edge would read as the wall and push the hips off into the well)
    var seatH = t.seat ? t.seat[2] : null;
    var hy = (seatH != null ? seatH : floor) + rP, hx = 0, it, i;
    for (it = 0; it < 3; it++) {
      hx = -Infinity;
      for (i = 0; i < rel.length; i++) {
        var yy = hy + rel[i].y;
        if (yy <= hy - rP + 0.35) continue;
        if (seatH != null && yy < seatH + 0.5) continue;
        var w = P.leftWall(yy);
        if (w === -Infinity) continue;
        hx = Math.max(hx, w - rel[i].x);
      }
      if (hx === -Infinity) hx = t.L * 0.3;
      var fl = floor;
      for (var xx = hx - rP * 0.5; xx <= hx + rP * 0.3; xx += 0.25) fl = Math.max(fl, P.at(xx));
      if (seatH != null && hx <= t.seat[1] + rP * 0.5) fl = Math.max(fl, seatH); // on the seat
      hy = fl + rP;
    }
    var hip = { x: hx, y: hy };
    var S = { x: hip.x + sh.x, y: hip.y + sh.y }, N = { x: hip.x + nk.x, y: hip.y + nk.y }, C = { x: hip.x + hc.x, y: hip.y + hc.y };

    // legs: straight first, heel on the floor
    var L2 = b.thigh + b.shank, fa0 = P.floorAt(hip.x + L2 * 0.9), ya = Math.min(fa0 == null ? floor : fa0, floor + 6) + b.ankleH, al = Math.asin(clamp((hy - ya) / L2, -1, 1));
    var dir = { x: Math.cos(al), y: -Math.sin(al) };
    var A = { x: hip.x + dir.x * L2, y: ya };
    // fit is judged with the feet flexed against the far wall (78 deg); the drawn foot then relaxes as far as the room allows
    var fa, fd, fp, footDeg = 78;
    function setFoot(deg) { fa = deg * DEG; fd = { x: Math.cos(fa), y: Math.sin(fa) }; fp = { x: Math.sin(fa), y: -Math.cos(fa) }; }
    // seat tubs: you sit with your feet flat on the well floor, not braced against the far wall
    setFoot(seatH != null ? 0 : 78);
    function legroomAt(ank) {
      var m = Infinity;
      for (var k = -3; k <= 10; k++) { // from the heel (below the ankle) up to the toes
        var so = b.sole != null ? b.sole : b.tFoot / 2, sx = ank.x + fd.x * b.foot * k / 10 + fp.x * so, sy = ank.y + fd.y * b.foot * k / 10 + fp.y * so;
        var lf = P.floorAt(sx); if (sy <= (lf == null ? floor : Math.max(floor, lf)) + 0.35) continue; // resting on (or just in) the floor under it is not a wall hit
        m = Math.min(m, P.rightWall(sy) - sx - (b.endGap || 0)); // endGap: extra clearance the 3D view asks for where the oval end curves in beside the feet
      }
      return m;
    }
    if (seatH != null) { // seat tubs: a seated bend, knees about 100 deg, feet flat on the well floor under them (never a diagonal stretch)
      var kneeA = 100 * DEG, reach = Math.sqrt(b.thigh * b.thigh + b.shank * b.shank - 2 * b.thigh * b.shank * Math.cos(kneeA));
      A = { x: hip.x + Math.sqrt(Math.max(0, reach * reach - (hy - ya) * (hy - ya))), y: ya };
      var wallX = P.rightWall(floor + 1); if (isFinite(wallX)) A.x = Math.min(A.x, wallX - b.foot - 0.5); // flat toes sit at floor level, below the wall check: keep them half an inch short of the far wall
    }
    var room = legroomAt(A), straight = seatH == null && room >= 0, K;
    if (straight) {
      K = { x: hip.x + dir.x * b.thigh, y: hip.y + dir.y * b.thigh };
    } else {
      A = { x: A.x + Math.min(0, room), y: ya };
      var vx = A.x - hip.x, vy = A.y - hip.y, d = Math.max(Math.hypot(vx, vy), Math.abs(b.thigh - b.shank) + 0.2);
      var aa = (b.thigh * b.thigh - b.shank * b.shank + d * d) / (2 * d), hh = Math.sqrt(Math.max(0, b.thigh * b.thigh - aa * aa));
      var mx = hip.x + vx * aa / d, my = hip.y + vy * aa / d;
      K = { x: mx - vy / d * hh, y: my + vx / d * hh };
      if (K.y < hip.y) K = { x: mx + vy / d * hh, y: my - vx / d * hh };
    }
    if (seatH != null) footDeg = 0;
    else for (var deg = 50; deg < 78; deg += 4) { setFoot(deg); if (legroomAt(A) >= 0) { footDeg = deg; break; } }
    setFoot(footDeg);
    var T = { x: A.x + fd.x * b.foot, y: A.y + fd.y * b.foot };
    // arm rests along the body onto the thigh
    var fr = { x: -nb.x, y: -nb.y }, da = { x: -u.x * 0.93 + fr.x * 0.37, y: -u.y * 0.93 + fr.y * 0.37 }, dl = Math.hypot(da.x, da.y);
    var E = { x: S.x + da.x / dl * b.upperArm, y: S.y + da.y / dl * b.upperArm };
    var tg = { x: hip.x + (K.x - hip.x) * 0.6, y: hip.y + (K.y - hip.y) * 0.6 + b.tThigh / 2 + b.tArm / 2 };
    var dw = Math.hypot(tg.x - E.x, tg.y - E.y) || 1, Wr = { x: E.x + (tg.x - E.x) / dw * b.foreArm, y: E.y + (tg.y - E.y) / dw * b.foreArm };

    var water = P.water;
    var kneeTop = K.y + b.tThigh / 2, kneeAbove = kneeTop - water;
    var reach = (water - hip.y) / Math.sin(phi) / b.torso;
    var waterTo = reach >= 1.0 ? 'Shoulders under water' : reach >= 0.85 ? 'Up to your collarbone' : reach >= 0.52 ? 'Up to your chest' : reach >= 0.3 ? 'Up to your waist' : 'Up to your hips';
    var hipSpare = (P.hipWidth(hip.x) - b.hipW) / 2;
    var fillGal = Math.max(0, t.gal - b.volGal * 0.85);

    // Describe the soak, never grade it: every result is a way to enjoy the tub.
    var styleId = straight ? (room >= 2 ? 'stretch' : 'classic') : (kneeAbove <= 0 ? 'classic' : 'upright');
    var hipS = hipSpare >= 1.25 ? 'ok' : hipSpare >= 0.25 ? 'snug' : 'close';

    return { tub: t, body: b, mode: mode, phi: phi, hip: hip, S: S, N: N, C: C, K: K, A: A, T: T, E: E, W: Wr, hd: hd, u: u, nb: nb,
      straight: straight, room: room, kneeAbove: kneeAbove, waterTo: waterTo, reach: reach, hipSpare: hipSpare,
      fillGal: fillGal, water: water, hipS: hipS, footDeg: footDeg, styleId: styleId, style: STYLES[styleId] };
  }

  function waterPhrase(f) {
    return { 'Shoulders under water': 'over your shoulders', 'Up to your collarbone': 'up to your collarbone', 'Up to your chest': 'up to your chest',
      'Up to your waist': 'up to your waist', 'Up to your hips': 'up to your hips' }[f.waterTo];
  }

  function copy(f, tubs, size) {
    var lead;
    if (f.styleId === 'stretch') lead = 'Legs out straight with ' + r1(f.room) + '″ to spare, water ' + waterPhrase(f) + '.';
    else if (f.styleId === 'classic') lead = (f.straight ? 'Legs straight, feet resting on the far end' : 'Knees gently bent and under the water') + ', water ' + waterPhrase(f) + '.';
    else lead = 'Knees up a little, water ' + waterPhrase(f) + '.';
    if (f.hipS === 'snug') lead += ' A snug, cocooned fit at the hips.';
    else if (f.hipS === 'close') lead += ' A close fit at the hips.';
    // a posture tip when sitting up more would relax the legs
    if (f.styleId === 'upright' && f.mode.id !== 'up') {
      var up = fit(f.tub, f.body, 'up');
      if (up.style.rank > f.style.rank) lead += ' Sit up a little and your legs relax.';
    }
    var SIZES = sizesOf(tubs), more = null, idx = SIZES.indexOf(size);
    if (f.style.rank < 2) {
      for (var i = idx + 1; i < SIZES.length; i++) {
        var g = fit(tubs[SIZES[i]], f.body, f.mode.id);
        if (g.style.rank > f.style.rank) { more = { size: SIZES[i], model: tubs[SIZES[i]].model, gain: g.room - f.room, rank: g.style.rank }; break; }
      }
    }
    return { lead: lead, more: more };
  }

  /* ---------- drawing ---------- */
  var X0 = -8, X1 = 73, Y0 = -7.5, Y1 = 44, K10 = 10;
  function X(x) { return (x * K10).toFixed(1); }
  function Y(y) { return (-y * K10).toFixed(1); }
  function pt(p) { return X(p.x) + ',' + Y(p.y); }
  function circ(c, r, cls) { return '<circle class="' + cls + '" cx="' + X(c.x) + '" cy="' + Y(c.y) + '" r="' + (r * K10).toFixed(1) + '"/>'; }
  // tapered limb: two joint circles joined by their outer tangents (same fill, so it reads as one shape)
  function limb(a, b, ra, rb, cls) {
    var dx = b.x - a.x, dy = b.y - a.y, d = Math.hypot(dx, dy) || 1, px = -dy / d, py = dx / d;
    var q = [{ x: a.x + px * ra, y: a.y + py * ra }, { x: b.x + px * rb, y: b.y + py * rb }, { x: b.x - px * rb, y: b.y - py * rb }, { x: a.x - px * ra, y: a.y - py * ra }];
    return '<polygon class="' + cls + '" points="' + q.map(pt).join(' ') + '"/>' + circ(a, ra, cls) + circ(b, rb, cls);
  }
  // closed Catmull-Rom spline through points, as cubic Beziers
  function smooth(ps, cls) {
    var n = ps.length, d = 'M' + pt(ps[0]);
    for (var i = 0; i < n; i++) {
      var p0 = ps[(i - 1 + n) % n], p1 = ps[i], p2 = ps[(i + 1) % n], p3 = ps[(i + 2) % n];
      var c1 = { x: p1.x + (p2.x - p0.x) / 6, y: p1.y + (p2.y - p0.y) / 6 }, c2 = { x: p2.x - (p3.x - p1.x) / 6, y: p2.y - (p3.y - p1.y) / 6 };
      d += 'C' + pt(c1) + ' ' + pt(c2) + ' ' + pt(p2);
    }
    return '<path class="' + cls + '" d="' + d + 'Z"/>';
  }
  // torso outline: back and front offsets from the hip-shoulder axis at stations along it (fractions of torso length)
  var TORSO = {
    m: { t: [-0.04, 0.12, 0.32, 0.5, 0.7, 0.88, 1.0], back: [1.0, 1.0, 0.9, 0.88, 0.95, 0.9, 0.72], front: [0.85, 0.9, 0.96, 1.0, 1.06, 0.95, 0.68] },
    f: { t: [-0.04, 0.12, 0.32, 0.5, 0.68, 0.86, 1.0], back: [1.1, 1.06, 0.88, 0.8, 0.86, 0.86, 0.7], front: [0.88, 0.9, 0.82, 0.78, 1.22, 0.92, 0.64] }
  };
  function torsoShape(f) {
    var b = f.body, sp = TORSO[b.sex], rP = b.tPelvis / 2, rT = b.tTorso / 2, back = [], front = [];
    for (var i = 0; i < sp.t.length; i++) {
      var t = sp.t[i], r = rP + (rT - rP) * clamp(t / 0.5, 0, 1), s = t * b.torso;
      var c = { x: f.hip.x + f.u.x * s, y: f.hip.y + f.u.y * s };
      back.push({ x: c.x + f.nb.x * r * sp.back[i], y: c.y + f.nb.y * r * sp.back[i] });
      front.unshift({ x: c.x - f.nb.x * r * sp.front[i], y: c.y - f.nb.y * r * sp.front[i] });
    }
    return smooth(back.concat(front), 'bfit-bf');
  }

  function draw(f) {
    var t = f.tub, P = prep(t), b = f.body, n = P.inner.length, i, x, parts = [];
    var xs = function (k) { return k * t.step; };
    var far = [], sec = [], wat = [];
    for (i = 0; i < n; i++) far.push(X(xs(i)) + ',' + Y(P.silTop[i]));
    for (i = n - 1; i >= 0; i--) far.push(X(xs(i)) + ',' + Y(P.silBot[i]));
    var farIn = [];
    for (i = 0; i < n; i++) farIn.push(X(xs(i)) + ',' + Y(P.silTop[i]));
    for (i = n - 1; i >= 0; i--) farIn.push(X(xs(i)) + ',' + Y(Math.min(P.inner[i], P.silTop[i])));
    for (i = 0; i < n; i++) sec.push(X(xs(i)) + ',' + Y(P.inner[i]));
    for (i = n - 1; i >= 0; i--) sec.push(X(xs(i)) + ',' + Y(P.outer[i]));
    var wl = P.leftWall(f.water), wr = P.rightWall(f.water);
    wat.push(X(wl) + ',' + Y(f.water));
    for (x = Math.ceil(wl / t.step) * t.step; x <= wr; x += t.step) wat.push(X(x) + ',' + Y(Math.min(P.at(x), f.water)));
    wat.push(X(wr) + ',' + Y(f.water));

    parts.push('<line class="bfit-ground" x1="' + X(X0) + '" y1="0" x2="' + X(X1) + '" y2="0"/>');
    parts.push('<polygon class="bfit-far" points="' + far.join(' ') + '"/>');
    parts.push('<polygon class="bfit-farin" points="' + farIn.join(' ') + '"/>');
    parts.push('<polyline class="bfit-rim" points="' + farIn.slice(0, n).join(' ') + '"/>');
    // body
    var g = [], R = b.headR, face = { x: f.hd.y, y: -f.hd.x };
    g.push(limb(f.K, f.A, b.tShank / 2, b.tShank * 0.3, 'bfit-bf'));
    g.push(limb(f.A, f.T, b.tFoot * 0.42, b.tFoot * 0.26, 'bfit-bf'));
    g.push(circ({ x: f.A.x - b.tFoot * 0.15, y: f.A.y - b.ankleH * 0.35 }, b.tFoot * 0.4, 'bfit-bf')); // heel
    g.push(limb(f.hip, f.K, b.tThigh * 0.56, b.tThigh * 0.36, 'bfit-bf'));
    g.push(circ(f.hip, b.tPelvis / 2, 'bfit-bf'));
    g.push(torsoShape(f));
    g.push(limb(f.S, f.N, b.tNeck / 2, b.tNeck * 0.45, 'bfit-bf'));
    // hair first, so the head covers all but a crescent at the back and crown
    g.push(circ({ x: f.C.x - face.x * R * 0.16 + f.hd.x * R * 0.12, y: f.C.y - face.y * R * 0.16 + f.hd.y * R * 0.12 }, R * (b.sex === 'f' ? 1.06 : 1.0), 'bfit-hair'));
    if (b.sex === 'f') g.push(circ({ x: f.C.x - face.x * R * 0.92 + f.hd.x * R * 0.42, y: f.C.y - face.y * R * 0.92 + f.hd.y * R * 0.42 }, R * 0.42, 'bfit-hair')); // bun
    g.push(circ(f.C, R * 0.97, 'bfit-bf'));
    g.push(circ({ x: f.C.x + face.x * R * 0.9 - f.hd.x * R * 0.02, y: f.C.y + face.y * R * 0.9 - f.hd.y * R * 0.02 }, R * 0.17, 'bfit-bf')); // nose
    g.push(limb(f.S, f.E, b.tArm * 0.55, b.tArm * 0.4, 'bfit-b2'));
    g.push(limb(f.E, f.W, b.tArm * 0.4, b.tArm * 0.3, 'bfit-b2'));
    g.push(circ(f.W, b.tArm * 0.45, 'bfit-b2'));
    parts.push('<g class="bfit-body">' + g.join('') + '</g>');
    parts.push('<polygon class="bfit-water" points="' + wat.join(' ') + '"/>');
    parts.push('<line class="bfit-wline" x1="' + X(wl) + '" y1="' + Y(f.water) + '" x2="' + X(wr) + '" y2="' + Y(f.water) + '"/>');
    parts.push('<polygon class="bfit-sec" points="' + sec.join(' ') + '"/>');

    // annotations
    var ann = [];
    var depth = f.water - t.floor;
    ann.push('<text class="bfit-t bfit-wt" x="' + X(wr - 1.5) + '" y="' + Y(f.water + 0.8) + '">water at overflow</text>');
    var dy = -4.2, xl = P.leftWall(t.rimLow - 0.5), xr = P.rightWall(t.rimLow - 0.5);
    ann.push('<line class="bfit-dim" x1="' + X(xl) + '" y1="' + Y(dy) + '" x2="' + X(xr) + '" y2="' + Y(dy) + '"/>');
    ann.push('<line class="bfit-dim" x1="' + X(xl) + '" y1="' + Y(dy - 1) + '" x2="' + X(xl) + '" y2="' + Y(dy + 1) + '"/>');
    ann.push('<line class="bfit-dim" x1="' + X(xr) + '" y1="' + Y(dy - 1) + '" x2="' + X(xr) + '" y2="' + Y(dy + 1) + '"/>');
    ann.push('<text class="bfit-t bfit-mid" x="' + X((xl + xr) / 2) + '" y="' + Y(dy - 3) + '">Inside ' + r1(P.innerLen) + '″ at the rim · ' + r1(P.flatLen) + '″ flat floor</text>');
    if (f.straight) {
      var ty = f.A.y + b.foot * 0.55, fx = f.A.x + Math.cos(78 * DEG) * b.foot * 0.55 + Math.sin(78 * DEG) * (b.sole != null ? b.sole : b.tFoot / 2), wx = P.rightWall(ty);
      if (isFinite(wx) && wx - fx > 0.6) {
        ann.push('<line class="bfit-room" x1="' + X(fx) + '" y1="' + Y(ty) + '" x2="' + X(wx) + '" y2="' + Y(ty) + '"/>');
        ann.push('<text class="bfit-t bfit-mid bfit-good" x="' + X((fx + wx) / 2) + '" y="' + Y(ty + 2.2) + '">' + r1(f.room) + '″</text>');
      }
    }
    parts.push(ann.join(''));
    return parts.join('');
  }

  /* ---------- UI ---------- */
  var CSS = [
    '.bfit{--bf-ink:#1a1a1a;--bf-muted:#6b665f;--bf-line:rgba(26,26,26,.14);--bf-bg:#faf8f5;--bf-card:#fff;--bf-stone:#ece6de;--bf-stone2:#f4f0ea;',
    '--bf-body:#6f655b;--bf-body2:#8a7f73;--bf-hair:#3b342e;--bf-water:rgba(104,148,166,.36);--bf-wline:#4f7f93;--bf-green:#4e7d5b;',
    'font-family:Inter,"Helvetica Neue",Arial,sans-serif;color:var(--bf-ink);background:var(--bf-bg);-webkit-font-smoothing:antialiased;line-height:1.45}',
    '.bfit *{box-sizing:border-box}',
    '.bfit-head{display:flex;align-items:flex-start;justify-content:space-between;gap:16px;padding:0 0 18px}',
    '.bfit-eyebrow{font-size:11.5px;letter-spacing:.14em;text-transform:uppercase;color:var(--bf-muted);margin:0 0 6px}',
    '.bfit-title{font-family:Cormorant,"Cormorant Garamond",Georgia,serif;font-weight:700;font-size:32px;line-height:1.1;margin:0;letter-spacing:0}',
    '.bfit-close{appearance:none;border:1px solid var(--bf-line);background:var(--bf-card);width:40px;height:40px;border-radius:2px;font-size:20px;line-height:1;cursor:pointer;color:var(--bf-ink);flex:none}',
    '.bfit-grid{display:grid;grid-template-columns:minmax(0,290px) minmax(0,1fr);grid-template-rows:auto 1fr;grid-template-areas:"you stage" "how stage";gap:16px 20px;align-items:start}',
    '.bfit-you{grid-area:you}.bfit-how{grid-area:how}.bfit-stage{grid-area:stage}',
    '.bfit-controls{display:flex;flex-direction:column;gap:22px;background:var(--bf-card);border:1px solid var(--bf-line);border-radius:4px;padding:20px}',
    '.bfit-label{display:flex;justify-content:space-between;align-items:baseline;gap:8px;font-size:11.5px;letter-spacing:.14em;text-transform:uppercase;color:var(--bf-muted);margin:0 0 10px}',
    '.bfit-label output{font-size:15px;letter-spacing:0;text-transform:none;color:var(--bf-ink);font-weight:600;font-variant-numeric:tabular-nums}',
    '.bfit-label output small{font-weight:400;color:var(--bf-muted);font-size:12.5px}',
    '.bfit input[type=range]{-webkit-appearance:none;appearance:none;width:100%;height:24px;background:transparent;margin:0;cursor:pointer}',
    '.bfit input[type=range]::-webkit-slider-runnable-track{height:2px;background:var(--bf-ink)}',
    '.bfit input[type=range]::-moz-range-track{height:2px;background:var(--bf-ink)}',
    '.bfit input[type=range]::-webkit-slider-thumb{-webkit-appearance:none;width:18px;height:18px;border-radius:50%;background:var(--bf-card);border:2px solid var(--bf-ink);margin-top:-8px}',
    '.bfit input[type=range]::-moz-range-thumb{width:14px;height:14px;border-radius:50%;background:var(--bf-card);border:2px solid var(--bf-ink)}',
    '.bfit input[type=range]:focus-visible{outline:2px solid var(--bf-wline);outline-offset:4px}',
    '.bfit-chips,.bfit-seg{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}',
    '.bfit-seg{margin-top:0}',
    '.bfit-chip{appearance:none;font:inherit;font-size:12.5px;padding:7px 10px;border:1px solid rgba(26,26,26,.18);background:var(--bf-card);color:var(--bf-ink);border-radius:2px;cursor:pointer;font-variant-numeric:tabular-nums}',
    '.bfit-seg .bfit-chip{flex:1 1 0;text-align:center;padding:9px 6px}',
    '.bfit-chip[aria-pressed=true]{background:var(--bf-ink);color:#fff;border-color:var(--bf-ink)}',
    '.bfit-chip:focus-visible,.bfit-size:focus-visible,.bfit-close:focus-visible,.bfit-link:focus-visible{outline:2px solid var(--bf-wline);outline-offset:2px}',
    '.bfit-sizes{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:6px}',
    '.bfit-size{appearance:none;font:inherit;text-align:left;border:1px solid rgba(26,26,26,.18);background:var(--bf-card);color:var(--bf-ink);border-radius:2px;padding:8px 9px;cursor:pointer;display:flex;flex-direction:column;gap:2px}',
    '.bfit-size b{font-size:13px}',
    '.bfit-size em{font-style:normal;font-size:12px;font-weight:500;color:var(--bf-ink);margin-top:2px}',
    '.bfit-size span{font-size:11.5px;color:var(--bf-muted);font-variant-numeric:tabular-nums}',
    '.bfit-size[aria-pressed=true]{border-color:var(--bf-ink);box-shadow:inset 0 0 0 1px var(--bf-ink)}',
    '.bfit-stage{background:var(--bf-card);border:1px solid var(--bf-line);border-radius:4px;overflow:hidden;min-width:0}',
    '.bfit-verdict{padding:18px 20px 0}',
    '.bfit-kicker{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--bf-muted);margin:0 0 2px}',
    '.bfit-verdict h3{font-family:Cormorant,"Cormorant Garamond",Georgia,serif;font-weight:700;font-size:28px;line-height:1.15;margin:0}',
    '.bfit-verdict p{margin:4px 0 0;font-size:14px;color:var(--bf-muted);max-width:60ch}',
    '.bfit-verdict .bfit-kicker{margin:0 0 2px;font-size:11px}',
    '.bfit-more{color:var(--bf-ink)!important}',
    '.bfit-link{appearance:none;background:none;border:0;padding:0;font:inherit;color:var(--bf-ink);text-decoration:underline;text-underline-offset:3px;cursor:pointer;text-align:left}',
    '.bfit-link:focus-visible{outline:2px solid var(--bf-wline);outline-offset:2px}',
    '.bfit-svg{display:block;width:100%;height:auto;margin:6px 0 0}',
    '.bfit-ground{stroke:var(--bf-line);stroke-width:3}',
    '.bfit-far{fill:var(--bf-stone)}',
    '.bfit-farin{fill:var(--bf-stone2)}',
    '.bfit-rim{fill:none;stroke:rgba(26,26,26,.35);stroke-width:2.5}',
    '.bfit-bf{fill:var(--bf-body)}.bfit-b2{fill:var(--bf-body2)}.bfit-hair{fill:var(--bf-hair)}',
    '.bfit-water{fill:var(--bf-water)}',
    '.bfit-wline{stroke:var(--bf-wline);stroke-width:3;stroke-dasharray:14 8}',
    '.bfit-sec{fill:#fdfcfa;stroke:var(--bf-ink);stroke-width:3.2;stroke-linejoin:round}',
    '.bfit-dim{stroke:var(--bf-muted);stroke-width:2}',
    '.bfit-room{stroke:var(--bf-green);stroke-width:3.5;stroke-linecap:round}',
    '.bfit-t{font-family:Inter,Arial,sans-serif;font-size:21px;fill:var(--bf-muted);font-variant-numeric:tabular-nums}',
    '.bfit-wt{fill:var(--bf-wline);font-size:18px;text-anchor:end}',
    '.bfit-mid{text-anchor:middle}.bfit-good{fill:var(--bf-green);font-weight:600}',
    '.bfit-stats{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));border-top:1px solid var(--bf-line)}',
    '.bfit-stat{padding:14px 16px;border-left:1px solid var(--bf-line);min-width:0}',
    '.bfit-stat:first-child{border-left:0}',
    '.bfit-stat dt{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:var(--bf-muted);margin:0 0 6px}',
    '.bfit-stat dd{margin:0;font-size:15px;font-weight:600;font-variant-numeric:tabular-nums}',
    '.bfit-stat dd small{display:block;font-weight:400;font-size:12.5px;color:var(--bf-muted);margin-top:2px}',
    '.bfit-foot{font-size:12.5px;color:var(--bf-muted);margin:14px 0 0;max-width:80ch}',
    '.bfit-foot a{color:var(--bf-ink)}',
    '@media (max-width:760px){.bfit-grid{grid-template-columns:minmax(0,1fr);grid-template-rows:auto;grid-template-areas:"you" "stage" "how";gap:12px}.bfit-stats{grid-template-columns:repeat(2,minmax(0,1fr))}',
    '.bfit-stat:nth-child(3){border-left:0}.bfit-stat:nth-child(n+3){border-top:1px solid var(--bf-line)}.bfit-title{font-size:27px}.bfit-verdict h3{font-size:24px}.bfit-controls{padding:16px;gap:18px}}'
  ].join('\n');

  function injectCSS(doc) {
    if (doc.getElementById('bfit-css')) return;
    var s = doc.createElement('style'); s.id = 'bfit-css'; s.textContent = CSS; doc.head.appendChild(s);
  }

  function mount(el, opts) {
    var DEF = { f: { h: 64, lb: 150 }, m: { h: 69, lb: 185 } };
    var sex = opts.sex === 'm' ? 'm' : 'f';
    var tubs = opts.tubs, state = { sex: sex, size: opts.size || 'M', h: opts.height || DEF[sex].h, lb: opts.weight || DEF[sex].lb, mode: opts.mode || 'recline' };
    var uid = 'bfit' + Math.random().toString(36).slice(2, 7);
    injectCSS(el.ownerDocument);
    var SIZES = sizesOf(tubs), sizeBtns = SIZES.map(function (k) {
      var t = tubs[k];
      return '<button type="button" class="bfit-size" data-size="' + k + '" aria-pressed="false"><b>' + k + '</b><span>' + t.specLen + '″ long</span><em></em></button>';
    }).join('');
    var modeBtns = MODES.map(function (m) { return '<button type="button" class="bfit-chip" data-mode="' + m.id + '" aria-pressed="false">' + m.label + '</button>'; }).join('');
    var sexBtns = '<button type="button" class="bfit-chip" data-sex="f" aria-pressed="false">Female</button><button type="button" class="bfit-chip" data-sex="m" aria-pressed="false">Male</button>';
    var presets = [60, 64, 69, 74].map(function (h) { return '<button type="button" class="bfit-chip" data-h="' + h + '" aria-pressed="false">' + ftin(h) + '</button>'; }).join('');
    el.innerHTML =
      '<div class="bfit" role="' + (opts.modal ? 'dialog' : 'region') + '" aria-label="Body Fit">' +
      '<div class="bfit-head"><div><p class="bfit-eyebrow">Body Fit · BW-03 double slipper</p><h2 class="bfit-title">See yourself in this tub</h2></div>' +
      (opts.modal ? '<button type="button" class="bfit-close" data-close aria-label="Close Body Fit">×</button>' : '') + '</div>' +
      '<div class="bfit-grid"><div class="bfit-controls bfit-you">' +
      '<div class="bfit-seg" role="group" aria-label="Body">' + sexBtns + '</div>' +
      '<div><div class="bfit-label"><label for="' + uid + '-h">Your height</label><output data-o="h"></output></div>' +
      '<input type="range" id="' + uid + '-h" min="56" max="80" step="0.5" data-in="h"><div class="bfit-chips">' + presets + '</div></div>' +
      '<div><div class="bfit-label"><label for="' + uid + '-w">Your weight</label><output data-o="w"></output></div>' +
      '<input type="range" id="' + uid + '-w" min="90" max="350" step="5" data-in="w"></div>' +
      '</div><div class="bfit-controls bfit-how">' +
      '<div><div class="bfit-label"><span>How you soak</span></div><div class="bfit-seg">' + modeBtns + '</div></div>' +
      '<div><div class="bfit-label"><span>Tub size</span><output data-o="s"></output></div><div class="bfit-sizes">' + sizeBtns + '</div></div>' +
      '</div><div class="bfit-stage"><div class="bfit-verdict"><p class="bfit-kicker">Your soak</p><h3 data-o="head"></h3><p data-o="sent"></p><p class="bfit-more" data-o="more" hidden></p></div>' +
      '<svg class="bfit-svg" viewBox="' + (X0 * K10) + ' ' + (-Y1 * K10) + ' ' + ((X1 - X0) * K10) + ' ' + ((Y1 - Y0) * K10) + '" role="img" aria-label="Side view of you in the tub"></svg>' +
      '<dl class="bfit-stats"><div class="bfit-stat"><dt>Legroom</dt><dd data-o="v1"></dd></div>' +
      '<div class="bfit-stat"><dt>Hip room</dt><dd data-o="v2"></dd></div>' +
      '<div class="bfit-stat"><dt>Water line</dt><dd data-o="v3"></dd></div>' +
      '<div class="bfit-stat"><dt>Water to fill</dt><dd data-o="v4"></dd></div></dl></div></div>' +
      '<p class="bfit-foot">Drawn to scale from each tub’s 3D model, cut down the centre, with the overflow depth from its data sheet. Bodies vary, so use this as a guide. To check your space at home, <a href="#" data-tpl>order a free paper tub template</a>.</p></div>';
    var q = function (s) { return el.querySelector(s); }, qa = function (s) { return Array.prototype.slice.call(el.querySelectorAll(s)); };
    var hIn = q('[data-in=h]'), wIn = q('[data-in=w]');
    hIn.value = state.h; wIn.value = state.lb;
    function render() {
      var b = bodyDims(state.h, state.lb, state.sex), t = tubs[state.size], f = fit(t, b, state.mode), c = copy(f, tubs, state.size);
      q('[data-o=h]').innerHTML = ftin(state.h) + ' <small>' + Math.round(state.h * 2.54) + ' cm</small>';
      q('[data-o=w]').innerHTML = state.lb + ' lb <small>' + Math.round(state.lb * 0.4536) + ' kg</small>';
      q('[data-o=s]').innerHTML = t.model;
      qa('[data-sex]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.sex === state.sex)); });
      qa('[data-h]').forEach(function (x) { x.setAttribute('aria-pressed', String(+x.dataset.h === state.h)); });
      qa('[data-mode]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.mode === state.mode)); });
      qa('.bfit-size').forEach(function (x) {
        var k = x.dataset.size, g = fit(tubs[k], b, state.mode);
        x.setAttribute('aria-pressed', String(k === state.size));
        x.querySelector('em').textContent = g.style.name;
        x.setAttribute('aria-label', tubs[k].model + ', ' + g.style.name);
      });
      q('[data-o=head]').textContent = f.style.name;
      q('[data-o=sent]').textContent = c.lead;
      var mo = q('[data-o=more]');
      if (c.more) { mo.innerHTML = (c.more.rank === 2 ? 'Want to stretch out?' : 'Want more room?') + ' <button type="button" class="bfit-link" data-go="' + c.more.size + '">The ' + c.more.model + ' gives you ' + r1(c.more.gain) + '″ more legroom →</button>'; mo.hidden = false; }
      else { mo.innerHTML = ''; mo.hidden = true; }
      // fit the drawing's height to the pose so there is no empty band above a reclined body
      var top = Math.ceil(Math.max(30, f.C.y + b.headR + 2) / 2) * 2, svg = q('svg');
      svg.setAttribute('viewBox', (X0 * K10) + ' ' + (-top * K10) + ' ' + ((X1 - X0) * K10) + ' ' + ((top - Y0) * K10));
      svg.innerHTML = draw(f);
      q('[data-o=v1]').innerHTML = f.straight ? r1(f.room) + '″ to spare<small>Legs out straight</small>'
        : (f.kneeAbove <= 0 ? 'Knees bent<small>Knees stay under the water</small>' : 'Knees up<small>' + r1(f.kneeAbove) + '″ above the water</small>');
      q('[data-o=v2]').innerHTML = f.hipS === 'ok' ? r1(f.hipSpare) + '″ each side<small>' + r1(prep(t).hipWidth(f.hip.x)) + '″ wide at your hips</small>'
        : 'Snug<small>' + r1(Math.max(0, f.hipSpare)) + '″ each side</small>';
      q('[data-o=v3]').innerHTML = f.waterTo + '<small>Overflow ' + r1(t.overflow != null ? t.overflow : f.water - t.floor) + '″ deep</small>';
      q('[data-o=v4]').innerHTML = '≈' + Math.round(f.fillGal) + ' gal<small>with you in (' + t.gal + ' gal empty)</small>';
      if (opts.onChange) opts.onChange(state, f);
    }
    hIn.addEventListener('input', function () { state.h = +hIn.value; render(); });
    wIn.addEventListener('input', function () { state.lb = +wIn.value; render(); });
    el.addEventListener('click', function (e) {
      var tg = e.target.closest('button,a'); if (!tg || !el.contains(tg)) return;
      if (tg.dataset.sex) { state.sex = tg.dataset.sex; state.h = DEF[state.sex].h; state.lb = DEF[state.sex].lb; hIn.value = state.h; wIn.value = state.lb; render(); }
      else if (tg.dataset.h) { state.h = +tg.dataset.h; hIn.value = state.h; render(); }
      else if (tg.dataset.mode) { state.mode = tg.dataset.mode; render(); }
      else if (tg.dataset.size) { state.size = tg.dataset.size; render(); }
      else if (tg.dataset.go) { state.size = tg.dataset.go; render(); }
      else if (tg.hasAttribute('data-close') && opts.onClose) opts.onClose();
      else if (tg.hasAttribute('data-tpl')) { e.preventDefault(); if (opts.onTemplate) opts.onTemplate(); }
    });
    render();
    return { set: function (k, v) { state[k] = v; if (k === 'h') hIn.value = v; if (k === 'lb') wIn.value = v; render(); }, state: state };
  }

  var api = { mount: mount, fit: fit, copy: copy, bodyDims: bodyDims, prep: prep, MODES: MODES, STYLES: STYLES, modesFor: modesFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = api; else root.BodyFit = api;
})(typeof window !== 'undefined' ? window : this);
